import { render, staticRenderFns } from "./fileAttachment.vue?vue&type=template&id=3ffc7cf3&scoped=true&"
import script from "./fileAttachment.vue?vue&type=script&lang=js&"
export * from "./fileAttachment.vue?vue&type=script&lang=js&"
import style0 from "./fileAttachment.vue?vue&type=style&index=0&id=3ffc7cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc7cf3",
  null
  
)

export default component.exports